// extracted by mini-css-extract-plugin
export var banner = "_s7-0";
export var settingRow = "_s7-2";
export var titleIcon = "_s7-1";